import { css } from '@emotion/react';
import { centerTextCss } from 'styles/utils';
import { IColors } from 'types/colors';
import { linkPaddingCss } from './styles';

const resetPasswordCss = (colors: IColors, withPadding?: boolean) => css`
	${linkPaddingCss(colors)};
	${centerTextCss};
	display: block;
	${!withPadding && 'padding: unset;'}
`;

interface IProps {
	colors: IColors;
	callback: () => void;
	labels: string;
	withPadding?: boolean;
}

export const ResetPasswordLink = ({ colors, callback, labels, withPadding = false }: IProps) => {
	return (
		<a  data-testid="ResetPasswordLink-A201EB" css={resetPasswordCss(colors, withPadding)} onClick={() => callback()}>
			{labels}
		</a>
	);
};
